import { ChangeDetectorRef, Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DomSanitizer } from '@angular/platform-browser';
import { select, Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { TermsSettings } from 'src/app/models/preference-settings';
import { RootStoreState } from 'src/app/root-store';
import { AuthStoreAction, AuthStoreSelectors } from 'src/app/root-store/auth-store';
import { PreferencesAction, PreferencesSelectors } from 'src/app/root-store/preferences-store';
import { PreferenceDataService } from 'src/app/services/preference-data.service';
import { FormatComponent } from 'src/app/shared/base-components/format-component';
import { AuthUser } from '../../auth/auth-user';

export interface TermsModalData {
  terms: TermsSettings;
  tenantImage: string;
}

@Component({
  selector: 'app-terms-modal',
  templateUrl: './terms-modal.component.html',
  styleUrls: ['./terms-modal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatToolbarModule,
    TranslatePipe,
  ],
})
export class TermsModalComponent extends FormatComponent implements OnInit {
  terms: TermsSettings;
  hereByChecked: boolean;
  quoteText: string;
  quoteAuthor: string;
  authUser: AuthUser;

  constructor(
    private sanitizer: DomSanitizer,
    protected store: Store<RootStoreState.State>,
    protected cdRef: ChangeDetectorRef,
    protected preferenceDataService: PreferenceDataService,
    public dialogRef: MatDialogRef<TermsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TermsModalData,
  ) {
    super();
  }

  ngOnInit(): void {
    this.terms = this.data.terms;

    this.subscribe(this.store.pipe(select(PreferencesSelectors.selectPreferencesQuote)), (quote) => {
      if (quote) {
        this.quoteText = quote.quote;
        this.quoteAuthor = quote.quoteAuthor;
      }
    });
    this.subscribe(this.store.pipe(select(AuthStoreSelectors.selectAuthUser)), (authUser) => {
      this.authUser = authUser;
      // if (this.authUser) {
      //   this.showWelcomMessage();
      // }
    });
  }

  agree() {
    this.subscribe(this.preferenceDataService.postTermsAndCondition(true), ({ data }) => {
      if (data && data.state) {
        this.dialogRef.close(true);
        this.store.dispatch(PreferencesAction.loadPreferenceSettings({ isAuth: true, isTenantAdmin: false }));
      }
    });
  }

  deny() {
    this.subscribe(this.preferenceDataService.postTermsAndCondition(false), ({ data }) => {
      if (data && data.state) {
        this.store.dispatch(AuthStoreAction.logout());
        this.dialogRef.close();
      }
    });
  }

  transform(base64Image: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Image);
  }
}
